module.exports = __webpack_public_path__ + "media/components/videos_internal/diabetes-1_1_news-298b05401c6142f79d25c7ea630ae7df.jpg";